import { Icon } from '../icon';
import './index.scss'
import FileAdd from "../../assets/icons/ico-upload-cadastro.svg"
import File from "../../assets/icons/ico-doc.svg"
import Remove from "../../assets/icons/excluir-ico.svg";

import { useRef, useState, useEffect } from 'react';
export const FilePicker = ({ text = "Upload", onChange, label, updateField, validators = [], ...props }) => {
    const [file, setFile] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [invalidMessage, setInvalidMessage] = useState('');
    const [firstClick, setFirstClick] = useState(true);

    const picker = useRef(null);
    const clearFile = () => {
        setIsValid(false)
        setInvalidMessage("")
        setFile(null);
        // Coloquei aqui só pra garantir que o componente saiba quando um arquivo for removido
        if (onChange) onChange(null);
    }

    // Precisei modificar o onFileChange para o Validators no "Documentação" funcionar...
    const onFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        setIsValid(true);
        setInvalidMessage("");

        if (validators != null && validators.length > 0) {
            for (const validator of validators) {
                let data = { valid: true, message: "" }

                if (validator.argument != null && validator.argument !== undefined){
                    data = validator.func(selectedFile, validator.argument);
                }else {
                    data = validator.func(selectedFile);
                }

                if (data.valid === false) {
                    setIsValid(false);
                    setInvalidMessage(data.message)
                    break;
                }
            }
        }

        if (onChange) {
            onChange(selectedFile);
        }
    };

    useEffect(() => {
        if (picker?.current !== undefined) {
            if (validators != null && validators.length > 0) {
                for (const validator of validators) {
                    const data = validator.func(picker.current.files[0], validator.argument);
                    if (data.valid === false) {
                        setIsValid(false);
                        setInvalidMessage(data.message)
                        break;
                    }
                }
            }
        }
    }, [validators])

    useEffect(() => {
        if (updateField != null && updateField !== undefined) updateField(props.id, isValid)
    }, [isValid])

    return (
        <span className='form-col'>
            <label className='form-label'>{label}</label>

                <label className={file==null? `file-button` : `file-display`} style={props.style}>
                    <span className='icon'> <Icon icon={file==null? FileAdd : File} size={30} /> </span>
                    <span className="text"> {file==null? text : file.name}</span>
                    {file != null && <span className='remove' onClick={() => { clearFile() }}> <Icon icon={Remove} size={20} /> </span>}
                    <input style={{display: file == null? "" : "none"}} name={props.id} ref={picker} type='file' {...props} onChange={onFileChange} onClick={() => {setFirstClick(false)}} />
                </label>

                

            {(!firstClick && !isValid) && <span className="form-message"> {invalidMessage} </span>}

        </span>


    )
}